import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as componentAction from '../store/component.action';
import { checkArray, imageUrl, Page_Size as pageSixe } from '../../../Components/helper';

export const StateContext = createContext(null);

export default function ComponentOrderStateProvider({ children }) {
  const params = useParams();
  const dispatch = useDispatch();
  const template = params?.templateType;
  const supplierType = params?.supplierType;
  const reducerState = useSelector((redState) => redState);
  const {
    ComponentOrderReducer: { poListData, totalPOCount, editData, pOrderData, totalOrderCount, zipUrl },
  } = reducerState;
  const initialSetting = {
    hasMore: false,
    isPageLoader: false,
    pageIndex: 1,
    isLoading: false,
    templateListData: [],
    selectedTemplate: [],
    deletedId: null,
    deleteModal: false,
    deleteMultipleModal: false,
    pageSize: pageSixe,
    searchText: '',
    sortOrder: '',
    sortPropertyName: '',
    searchLoaded: false,
    openPreviewModal: false,
    previewData: null,
    loader: false,
    PurchaseOrderData: [],
    addPOModal: false,
  };

  const [Componentstate, setComponentState] = useState({ ...initialSetting });
  const { templateListData, PurchaseOrderData } = Componentstate;

  useEffect(() => {
    setComponentState((prev) => ({
      ...prev,
      previewData: editData,
    }));
  }, [editData]);

  useEffect(() => {
    return () => {
      setComponentState({ ...initialSetting });
      dispatch(componentAction.clearReducer());
    };
  }, [dispatch]);

  useEffect(() => {
    if (zipUrl?.zipUrl) {
      const path = zipUrl.zipUrl;
      const fileURL = `${imageUrl}/${path}`;

      // Extract pdfName by finding the part that includes "component-order-po"
      const pdfName = path.split('/').find((part) => part.includes('component-order-po')) || 'downloaded-file';

      fetch(fileURL)
        .then((response) => response.blob())
        .then((blob) => {
          const fileObjectURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = fileObjectURL;
          link.download = pdfName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileObjectURL);
        })
        .catch((error) => console.error('Download error:', error));
    }
  }, [zipUrl]);

  useEffect(() => {
    setComponentState((prev) => ({
      ...prev,
      searchText: '',
    }));
  }, [template]);

  useEffect(() => {
    const callFn = async () => {
      if (template === 'po-template') {
        const reqObj = {
          pageIndex: 1,
          pageSize: Componentstate?.pageSize,
          searchText: Componentstate?.searchText,
        };
        setComponentState((prev) => ({
          ...prev,
          isLoading: true,
        }));
        const res = await dispatch(componentAction.fetchPOTemplateList(reqObj));
        if (res) {
          setComponentState((prev) => ({
            ...prev,
            isLoading: false,
          }));
        }
      } else {
        const reqObj = {
          pageIndex: 1,
          pageSize: Componentstate?.pageSize,
          searchText: Componentstate?.searchText,
        };
        setComponentState((prev) => ({
          ...prev,
          isLoading: true,
        }));
        if (supplierType) {
          reqObj.supplierType = supplierType;
        }
        const res = await dispatch(componentAction.fetchPurchaseOrder(reqObj));
        if (res) {
          setComponentState((prev) => ({
            ...prev,
            isLoading: false,
          }));
        }
      }
    };

    callFn();
  }, [template]);

  const isallChecked = checkArray(templateListData) && Componentstate?.selectedTemplate.length === templateListData.length;

  const handleCheckTemplate = async (isTempChecked, tempId) => {
    const existingIds = Componentstate?.selectedTemplate;
    if (isTempChecked && !existingIds.includes(tempId)) {
      setComponentState((prevState) => ({
        ...prevState,
        selectedTemplate: [...existingIds, tempId],
      }));
    } else {
      const removedArray = existingIds?.filter((eleId) => eleId !== tempId);

      if (checkArray(removedArray)) {
        setComponentState((prevState) => ({
          ...prevState,
          selectedTemplate: removedArray,
        }));
      } else {
        setComponentState((prevState) => ({
          ...prevState,
          selectedTemplate: [],
        }));
      }
    }
  };

  const handleCheckAll = async (e) => {
    if (e.target.checked) {
      const allIds = templateListData && checkArray(templateListData) && templateListData.map((ele) => ele._id);

      if (allIds) {
        setComponentState((prevState) => ({
          ...prevState,
          selectedTemplate: allIds.filter((element) => element !== undefined),
        }));
      }
    } else {
      setComponentState((prevState) => ({
        ...prevState,
        selectedTemplate: [],
      }));
    }
  };

  useEffect(() => {
    if (poListData && !isEmpty(poListData)) {
      setComponentState((prev) => ({
        ...prev,
        templateListData: [...templateListData, ...poListData],
        hasMore: totalPOCount > [...templateListData, ...poListData]?.length,
      }));
    }
  }, [poListData, totalPOCount]);

  useEffect(() => {
    if (pOrderData && !isEmpty(pOrderData)) {
      setComponentState((prev) => ({
        ...prev,
        PurchaseOrderData: [...PurchaseOrderData, ...pOrderData],
        hasMore: totalOrderCount > [...PurchaseOrderData, ...pOrderData]?.length,
      }));
    }
  }, [pOrderData, totalOrderCount]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      let res;
      if (template === 'po-template' && Componentstate.searchLoaded) {
        setComponentState((debouncestate) => ({
          ...debouncestate,
          pageIndex: 1,
          hasMore: true,
          templateListData: [],
          isLoading: true,
        }));
        dispatch(componentAction.clearReducer());
        const reqObj = {
          pageIndex: Componentstate?.pageIndex,
          pageSize: Componentstate?.pageSize,
          searchText: Componentstate?.searchText,
        };
        res = await dispatch(componentAction.fetchPOTemplateList(reqObj));
      } else if (Componentstate.searchLoaded) {
        setComponentState((debouncestate) => ({
          ...debouncestate,
          pageIndex: 1,
          hasMore: true,
          PurchaseOrderData: [],
          isLoading: true,
        }));
        const reqObj = {
          pageIndex: Componentstate?.pageIndex,
          pageSize: Componentstate?.pageSize,
          searchText: Componentstate?.searchText,
        };
        if (supplierType) {
          reqObj.supplierType = supplierType;
        }

        res = await dispatch(componentAction.fetchPurchaseOrder(reqObj));
      }
      if (res) {
        setComponentState((debstate) => ({
          ...debstate,
          searchLoaded: false,
          isLoading: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [Componentstate.searchText]);

  const handlePageNextInScroll = async () => {
    let pageIndex = Componentstate?.pageIndex;
    pageIndex += 1;
    setComponentState((nextPagestate) => ({
      ...nextPagestate,
      pageIndex,
      isPageLoader: true,
    }));
    const params = {
      pageIndex,
      pageSize: Componentstate?.pageSize,
      isScrolled: true,
    };
    if (Componentstate.searchText) {
      params.searchText = Componentstate.searchText;
    }

    if (Componentstate.sortOrder) {
      params.sortOrder = Componentstate?.sortOrder;
      params.sortPropertyName = Componentstate?.sortPropertyName;
    }

    const res = await dispatch(componentAction.fetchPOTemplateList(params));
    if (res) {
      setComponentState((prevState) => ({
        ...prevState,
        isPageLoader: false,
      }));
    }
  };

  const onSortColumn = async (e) => {
    let sortOrder = '';
    let sortPropertyName = '';
    if (Componentstate?.sortOrder === '' || Componentstate?.sortOrder === 'Desc' || Componentstate?.sortPropertyName !== e) {
      sortOrder = 'Asc';
      sortPropertyName = e;
      setComponentState((prevState) => ({
        ...prevState,
        sortOrder: 'Asc',
        sortPropertyName: e,
        isLoading: true,
        templateListData: [],
        selectedTemplate: [],
        pageIndex: 1,
      }));
    } else {
      sortOrder = 'Desc';
      sortPropertyName = e;
      setComponentState((prevState) => ({
        ...prevState,
        sortOrder: 'Desc',
        sortPropertyName: e,
        isLoading: true,
        templateListData: [],
        selectedTemplate: [],
        pageIndex: 1,
      }));
    }
    const params = {
      pageIndex: 1,
      pageSize: Componentstate?.pageSize,
      sortOrder,
      sortPropertyName,
    };
    await dispatch(componentAction.clearReducer()); // clear Reducer
    const res = await dispatch(componentAction.fetchPOTemplateList(params));
    if (res) {
      setComponentState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const onSortPOColumn = async (e) => {
    let sortOrder = '';
    let sortPropertyName = '';
    if (Componentstate?.sortOrder === '' || Componentstate?.sortOrder === 'Desc' || Componentstate?.sortPropertyName !== e) {
      sortOrder = 'Asc';
      sortPropertyName = e;
      setComponentState((prevState) => ({
        ...prevState,
        sortOrder: 'Asc',
        sortPropertyName: e,
        isLoading: true,
        PurchaseOrderData: [],
        pageIndex: 1,
      }));
    } else {
      sortOrder = 'Desc';
      sortPropertyName = e;
      setComponentState((prevState) => ({
        ...prevState,
        sortOrder: 'Desc',
        sortPropertyName: e,
        isLoading: true,
        PurchaseOrderData: [],
        pageIndex: 1,
      }));
    }
    const poData = {
      pageIndex: 1,
      pageSize: Componentstate?.pageSize,
      sortOrder,
      sortPropertyName,
    };
    await dispatch(componentAction.clearReducer()); // clear Reducer
    if (supplierType) {
      poData.supplierType = supplierType;
    }
    const res = await dispatch(componentAction.fetchPurchaseOrder(poData));
    if (res) {
      setComponentState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const contextValue = useMemo(
    () => ({
      Componentstate,
      setComponentState,
      handleCheckAll,
      isallChecked,
      handleCheckTemplate,
      handlePageNextInScroll,
      onSortColumn,
      onSortPOColumn,
    }),
    [Componentstate, setComponentState, handleCheckAll, isallChecked, handleCheckTemplate, handlePageNextInScroll, onSortColumn, onSortPOColumn],
  );

  return (
    <StateContext.Provider
      value={{
        ...contextValue,
      }}
    >
      {children}
    </StateContext.Provider>
  );
}

export function useComponentOrderState() {
  const context = useContext(StateContext);
  const { t } = useTranslation('common');
  if (!context) {
    throw new Error(t('ADD_PO_TEMPLATE_PROVIDER.STATE_PROVIDER'));
  }
  return context;
}
